export enum AdminResumeApiTags {
  Resume = 'AdminResume',
}

export const adminResumeApiTagTypes = Object.values(AdminResumeApiTags);
